(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ServiceContratDeleteController',ServiceContratDeleteController);

    ServiceContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'LigneContrat'];

    function ServiceContratDeleteController($uibModalInstance, entity, LigneContrat) {
        var vm = this;
        vm.contrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
        	LigneContrat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
